// Static content for iTowers Exente community portal

export const SOCIETY = {
  name: "iTowers Exente",
  subtitle: "A Kolte-Patil Community",
  tagline: "Future-proof spaces in the heart of Electronic City",
  location: "Konappana Agrahara, Electronic City, Bengaluru",
  mapsUrl: "https://maps.app.goo.gl/hToyqxHZ79yn1zj78",
  stats: [
    { value: "438", label: "Homes" },
    { value: "5", label: "Towers" },
    { value: "24", label: "Floors" },
    { value: "4", label: "Acres" },
  ],
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/amenities", label: "Amenities" },
  { to: "/community", label: "Community" },
  { to: "/visitors", label: "Visitors" },
  { to: "/residents", label: "Residents" },
  { to: "/policies", label: "Policies" },
  { to: "/contact", label: "Contact" },
];

export const AMENITIES = [
  {
    title: "Rooftop Infinity Pool",
    desc: "A sky-high pool with city views — the soul of weekends at Exente.",
    icon: "SwimmingPool",
    image: "https://images.pexels.com/photos/29149086/pexels-photo-29149086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    title: "Aristotle Digital Library",
    desc: "5,000+ titles, newspapers and a quiet reading lounge.",
    icon: "Books",
    image: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-5",
  },
  {
    title: "Clubhouse & Banquet",
    desc: "Indoor games, party hall and lounge for residents.",
    icon: "Confetti",
    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-5",
  },
  {
    title: "Landscaped Gardens",
    desc: "Themed gardens with shaded walks and bird-friendly planting.",
    icon: "Tree",
    image: "https://images.unsplash.com/photo-1597329739495-8dac13c8cc3b?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-4",
  },
  {
    title: "Tennis & Basketball Courts",
    desc: "Professional courts maintained for daily play.",
    icon: "TennisBall",
    image: "https://images.unsplash.com/photo-1542144582-1ba00456b5e3?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-4",
  },
  {
    title: "State-of-the-art Gym",
    desc: "Cardio, free weights and dedicated yoga studio.",
    icon: "Barbell",
    image: "https://images.unsplash.com/photo-1546483875-ad9014c88eba?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-4",
  },
  {
    title: "Kids' Play Zone & Pool",
    desc: "Safe zones designed for ages 2 — 12.",
    icon: "Baby",
    image: "https://images.unsplash.com/photo-1597464687210-04e1cbbecc0c?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-6",
  },
  {
    title: "Jogging Track & Party Lawn",
    desc: "A 600m loop circling open lawns and seating decks.",
    icon: "PersonSimpleRun",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1200&q=80",
    span: "md:col-span-6",
  },
];

export const VENDORS = [
  {
    name: "Brew & Bites Café",
    category: "Café · Bakery",
    offer: "10% off for residents",
    phone: "+91 98800 11122",
    image: "https://images.pexels.com/photos/12168917/pexels-photo-12168917.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400",
  },
  {
    name: "FreshKart Grocery",
    category: "Daily Essentials",
    offer: "Free home delivery inside Exente",
    phone: "+91 98800 22334",
    image: "https://images.pexels.com/photos/28670064/pexels-photo-28670064.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400",
  },
  {
    name: "PureWash Laundry",
    category: "Dry Clean · Laundry",
    offer: "₹49 wash & iron per kg",
    phone: "+91 98800 33445",
    image: "https://images.unsplash.com/photo-1610557892470-55d9e80c0bce?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "GreenLeaf Plants",
    category: "Plants · Décor",
    offer: "Buy 2 get 1 free saplings",
    phone: "+91 98800 44556",
    image: "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Aroma Salon & Spa",
    category: "Wellness",
    offer: "Flat 15% on memberships",
    phone: "+91 98800 55667",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "QuickFix Home Services",
    category: "Plumber · Electrician",
    offer: "Same-day service, no visit fee",
    phone: "+91 98800 66778",
    image: "https://images.unsplash.com/photo-1581578017093-cd30fce4eeb7?auto=format&fit=crop&w=900&q=80",
  },
];

export const EVENTS = [
  {
    title: "Republic Day Carnival",
    date: "Jan 26 · 9:00 AM",
    place: "Central Lawn",
    desc: "Flag hoisting, march-past by kids, breakfast and cultural performances.",
    image: "https://images.unsplash.com/photo-1551801841-ecad875a5142?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Holi at Exente",
    date: "Mar 14 · 10:00 AM",
    place: "Party Lawn",
    desc: "Organic colors, music, rain dance and curated street food stalls.",
    image: "https://images.unsplash.com/photo-1583952570326-da9b2dde64b5?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Summer Swim Camp",
    date: "Apr 2 — May 30",
    place: "Rooftop Pool",
    desc: "Certified coaches, batches for kids and adults. Register at the clubhouse.",
    image: "https://images.pexels.com/photos/12485724/pexels-photo-12485724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600",
  },
];

export const POLICIES = [
  {
    title: "Move-in / Move-out",
    points: [
      "Submit move-in form 48 hours prior at the management office.",
      "Lifts to be padded by Facility Team before any furniture movement.",
      "Movement timing: 8:00 AM — 7:00 PM only, except Sundays.",
    ],
  },
  {
    title: "Pets",
    points: [
      "Pets are welcome — please register them with the management.",
      "Leash inside common areas at all times.",
      "Owners are responsible for cleaning after their pets.",
    ],
  },
  {
    title: "Waste Segregation",
    points: [
      "Green bin: wet / organic waste, collected daily before 9 AM.",
      "Blue bin: dry / recyclable waste, collected Mon, Wed, Fri.",
      "Red bin: sanitary / hazardous waste, sealed in red bags.",
    ],
  },
  {
    title: "Flat Leakages",
    points: [
      "Upper flat owners bear waterproofing costs for source repair.",
      "Lower flat owners bear interior repainting after the issue is fixed.",
      "Raise tickets via the management office for joint inspection.",
    ],
  },
  {
    title: "Common Area Etiquette",
    points: [
      "Quiet hours: 10:00 PM — 7:00 AM.",
      "No smoking in lifts, lobbies, gym, pool or clubhouse.",
      "Children under 10 must be accompanied by adults at the pool.",
    ],
  },
  {
    title: "EV Charging",
    points: [
      "Six shared EV chargers in basement B1 (3.3 kW & 7.2 kW).",
      "Booking via management WhatsApp group — 2-hour slots.",
      "Personal EV points permitted after electrical approval.",
    ],
  },
];

export const COMMITTEE = [
  { name: "Anita Rao", role: "President" },
  { name: "Vikram Iyer", role: "Vice President" },
  { name: "Priya Menon", role: "Secretary" },
  { name: "Karthik Shetty", role: "Treasurer" },
  { name: "Rahul Verma", role: "Cultural Committee" },
  { name: "Deepa Krishnan", role: "Sports & Amenities" },
];
